<template lang="html">
  <v-app-bar :elevation="0" class="white">
    <v-tabs class="mx-auto">
      <v-tab
        v-for="(menuItem, index) in menuItems"
        :key="index"
        :to="menuItem.url"
        color="green"
        class="mx-0 mx-md-3 pa-0 pa-md-3"
      >
        {{ menuItem.name }}
      </v-tab>
      <v-tabs-slider color="green"></v-tabs-slider>
    </v-tabs>
  </v-app-bar>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
        menuItems: [
          {
            name: "トップ",
            url: "/",
          },
          {
            name: "出展タイトル",
            url: "/exhibit",
          },
          {
            name: "会場案内",
            url: "/access",
          },
          {
            name: "当日イベント",
            url: "/event",
          },
        ],
      };
    },
  };
</script>

<!-- <style scoped>
  @import "../styles/common/css/pageprimary.css";
</style> -->
